import { render, staticRenderFns } from "./categoryRegionSelect.vue?vue&type=template&id=7b18c0a4&scoped=true"
import script from "./categoryRegionSelect.vue?vue&type=script&lang=js"
export * from "./categoryRegionSelect.vue?vue&type=script&lang=js"
import style0 from "./categoryRegionSelect.vue?vue&type=style&index=0&id=7b18c0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b18c0a4",
  null
  
)

export default component.exports